export const disableVideoAutoplay = () => {
  const list = document.querySelectorAll('[data-video-embed]')
  if (list.length) {
    for (let i = 0; i < list.length; i++) {
      const video = list[i] as HTMLVideoElement
      video.addEventListener('play', () => {
        video.pause()
        video.currentTime = 0
      })
    }
  }
}
